var Handlebars = require("handlebars/dist/handlebars");
var HandlebarsIntl = require("handlebars-intl");

HandlebarsIntl.registerWith(Handlebars);

// Load Handlebars Helpers
require("./handlebars.helpers.js");

module.exports = Handlebars;
